<template>
    <div :id="'step_' + id"
        class="step d-flex justify-content-start align-items-center"
        :style="{ gap: '.25rem', paddingLeft: (16 * (3 + level)) + 'px' }"
        @click="() => $emit('set_active_step')"
    >
    <!-- :class="'step d-flex justify-content-start align-items-center' + (is_ready ? ' is_ready' : '')" -->
        
        <div class="step_checked" style="min-width: 16px;">
            <!-- <span :style="{ display: is_ready ? 'inline' : 'none' }">&#10003;</span> -->
        </div>
        
        <span class="step_title" :style="data.text_style ? data.text_style : ''">{{ step_name }}</span>
        
        <div class="natural-400 ml-auto" style="width: 16px;">
            <base-icon :id="'step_info' + id" v-if="tooltip_value" name="info" />
        </div>
        <b-tooltip v-if="tooltip_value" :target="'step_info' + id" triggers="hover" :container="tooltip_container" custom-class="step__tooltip">
            <span v-html="tooltip_value"></span>
        </b-tooltip>

    </div>
</template>

<script>
export default
{
    props :
    {
        is_ready : { type : Boolean, default : () => false },
        id : String,
        step_name : String,
        tooltip_value : { type : String, default : () => null },
        tooltip_container : { type : String, default : () => null },
        level : { type : Number, default : () => 0 },
        data : Object,
    }
}
</script>

<style>
.step__tooltip .tooltip-inner
{
    max-width: 450px;
}
</style>

<style scoped>
.step
{
    font-size: 0.75rem;
    border-radius: 0 .5rem .5rem 0;
    padding-block: .5rem;
    padding-right: .5rem;
    cursor: pointer;
}

/* .is_ready
{
    color: #3A9256;
} */
</style>